import { render, staticRenderFns } from "./labelPanelTypeBadge.vue?vue&type=template&id=6df6362a&"
import script from "./labelPanelTypeBadge.vue?vue&type=script&lang=js&"
export * from "./labelPanelTypeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports